import { monotonicFactory } from 'ulidx';

const generate = monotonicFactory();

export const ulid = () => {
  return generate().toLowerCase();
};
